let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("asfWY")).then(() => parcelRequire('iaTUL'));